var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.1485C1 10.7233 1.10835 10.3052 1.31483 9.93351L5.64497 2.13926C6.0288 1.44836 6.69664 0.960866 7.47165 0.805865V0.805865C7.82043 0.736109 8.17957 0.736109 8.52835 0.805865V0.805865C9.30335 0.960866 9.97121 1.44837 10.355 2.13926L14.6852 9.93351C14.8916 10.3052 15 10.7233 15 11.1485V11.1485C15 12.5301 13.8799 13.6502 12.4983 13.6502H3.50174C2.12006 13.6502 1 12.5301 1 11.1485V11.1485Z",
    stroke: "#FFB800",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.24967L8 7.58301",
    stroke: "#FFC400",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33333L8 9.625",
    stroke: "#FFC400",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.48768575303a97d93c80a437bf5b5791.svg";
export { ForwardRef as ReactComponent };